// Kept free of imports: `form-error.interface` reads these, and reaching them through
// `portal-config.interface` would loop back to it via the form utilities.

/** Product names shown for the SCREAMING_SNAKE names in `client.Entitlement`. */
export enum DisplayEntitlements {
  CARDS = 'Cards',
  ATO = 'Account Takeovers',
  CE = 'Compromised Employees',
  IOC = 'Indicators of Compromise',
  EXECUTIVE = 'Executive Monitoring',
  QUESTIONNAIRE = 'Client Questionnaire',
  THIRD_PARTY_RISK = 'Third Party Risk',
  FILESHARE = 'File Sharing',
  FRAUD_ALERTS = 'Fraud Alerts',
  CHECK_RECORDS = 'Check Records',
  ROI_SAVINGS = 'ROI and Savings',
  FRAUD_INSIGHTS = 'Fraud Insights',
  IMPACT_SUMMARY_LIST = 'Impact Summary List',
  CHECKGUARD = 'CheckGuard',
  RANSOMWARE_VICTIM = 'Ransomware Victims',
  ATO_ULP = 'Account Takeovers ULP',
  IOC_ULP = 'Indicators of Compromise ULP',
}

/** Falls back to the raw name so an entitlement missing here still renders. */
export const entitlementLabel = (name: string): string =>
  (DisplayEntitlements as Partial<Record<string, string>>)[name] ?? name;

/** Entitlements only meaningful alongside another, keyed by the one that depends. */
export const ENTITLEMENT_REQUIREMENTS: Readonly<Record<string, string>> = {
  EXECUTIVE: 'CE',
  ATO_ULP: 'ATO',
  IOC_ULP: 'IOC',
};

export const entitlementRequirementWarning = (dependent: string): string =>
  `${entitlementLabel(ENTITLEMENT_REQUIREMENTS[dependent])} entitlement is required when choosing ${entitlementLabel(dependent)}`;

export const entitlementRequirementsErrorMessage = (
  dependents: readonly string[]
): string =>
  dependents.length ? entitlementRequirementWarning(dependents[0]) : '';

export const entitlementRequirementsWarning = () =>
  Object.keys(ENTITLEMENT_REQUIREMENTS)
    .map(entitlementRequirementWarning)
    .join('. ');
